export const RESULT_FETCH_REQUEST = "RESULT_FETCH_REQUEST";
export const RESULT_FETCH_SUCCESS = "RESULT_FETCH_SUCCESS";
export const RESULT_FETCH_FAIL = "RESULT_FETCH_FAIL";

export const fetchResultRequest = () => {
    return {
        type: RESULT_FETCH_REQUEST,
    };
};

export const fetchResultSuccess = (quizQuestionData) => {
    return {
        type: RESULT_FETCH_SUCCESS,
        payload: quizQuestionData,
    };
};

export const fetchResultFailure = (error) => {
    return {
        type: RESULT_FETCH_FAIL,
        payload: error,
    };
};